var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 30.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #003189;\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #1a76cb;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #6c88bc;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preference_transfer-2",
    "data-name": "preference transfer-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6507",
    "data-name": "Group 6507"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1230",
    "data-name": "Line 1230",
    className: "cls-1",
    x1: 2,
    y1: 14.91,
    x2: 23,
    y2: 14.91
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6496-2",
    "data-name": "Group 6496-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046-2",
    "data-name": "Path 2046-2",
    className: "cls-2",
    d: "M15.39,25.89l-3,2.99-2.98-2.99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94-2",
    "data-name": "Line 94-2",
    className: "cls-2",
    x1: 12.4,
    y1: 27.36,
    x2: 12.4,
    y2: 22.41
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547",
    "data-name": "Rectangle 2547",
    className: "cls-3",
    d: "M22.5,5.91h0c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547-2",
    "data-name": "Rectangle 2547-2",
    className: "cls-3",
    d: "M22.5,27.91h0c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6502",
    "data-name": "Group 6502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547-3",
    "data-name": "Rectangle 2547-3",
    className: "cls-3",
    d: "M2.5,5.91h0c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547-4",
    "data-name": "Rectangle 2547-4",
    className: "cls-3",
    d: "M2.5,27.91h0c-1.1,0-2-.9-2-2H.5c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8558-2",
    "data-name": "Path 8558-2",
    className: "cls-2",
    d: "M9.41,4.4l3-2.99,2.98,2.99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1228-2",
    "data-name": "Line 1228-2",
    className: "cls-2",
    x1: 12.4,
    y1: 2.93,
    x2: 12.4,
    y2: 7.88
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveHover);
export default __webpack_public_path__ + "static/media/move-hover.f41f0e365d8e37d833fbb9db49d09c8f.svg";
export { ForwardRef as ReactComponent };